<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">选择服务人</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding:20px">

        <el-table :data="goodsInfo" class="table" border height="400">
          <el-table-column prop="name" fixed label="姓名" width="100"></el-table-column>
          <el-table-column prop="phone" fixed label="手机" width="120"></el-table-column>
          <el-table-column prop="gender" fixed label="性别">
            <template slot-scope="scope">
              <span v-if="scope.row.gender ==0">女</span>
              <span v-if="scope.row.gender ==1">男</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handleAdd(scope.$index, scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'GetGood',
  data() {
    return {

      loading: false,

      goodsInfo:[],
      totalItems:0,
      pageSize:20,
      currentPage:1,

      beforeCartBusinessCode:'',

    }
  },
  components:{

  },
  methods: {
    init(row){
      this.beforeCartBusinessCode=row.beforeCartBusinessCode
      this.currentPage = 1;
      this.getGoods()
    },
    closeSelf() {
      this.$emit("closeServe");
    },

    handleAdd(index,row){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"AppCare/BeforeCartChangeServe",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          serveCode:row.serveCode,
          beforeCartBusinessCode:this.beforeCartBusinessCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.$emit("closeServe");
          this.$emit("getCart");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })


    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getGoods();
    },

    getGoods(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/BusinessPage",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          pageSize:20,
          pageIndex:this.currentPage,
          name:"",
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.goodsInfo=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },



  }
}


</script>


